export default {
    name: 'kategori',
    state: {
        kategori: [
            {
                id: 1,
                value: "Project",
                label: "Proyek"
            },
            {
                id: 2,
                value: "Non Project",
                label: "Non Proyek"
            }
        ]
    },
    getters: {
        getKategori: state => {
            return state.kategori
        }
    },
    mutations: {

    },
    actions: {
    }
}